// Check if logged in user is admin
export const isAdmin = () => {
  const userRoles = localStorage.getItem("userRoles") ? JSON.parse(localStorage.getItem("userRoles")) : null;
  return Object.values(userRoles).indexOf("CPN_ADMIN") > -1;
};

